import { useCallback } from 'react';

import Link from '../../models/Engines/Link';
import EnginesService from '../../services/EnginesService';
import ErrorResponse from '../../types/ErrorResponse';
import ItemResponse from '../../types/ItemResponse';
import useItemQuery from '../useItemQuery';

const useEnginesRegenerateQuery = () => {
	const fetcher = useCallback(
		async (
			dataSetter: (data: ItemResponse<Link>) => void,
			errorSetter: (error: ErrorResponse) => void,
			domain: string,
		) => {
			await new EnginesService().regenerate(domain, dataSetter, errorSetter);
		},
		[],
	);

	return useItemQuery(fetcher);
};

export default useEnginesRegenerateQuery;
